module.exports = __webpack_public_path__ + "static/media/landing-page-comp-crop.1ce9fa26.png";